import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedRole = () => {
  return {
    resources: [],
    resourceGroups: [],
  };
};

export default {
  state: () => ({
    selectedRole: getDefaultSelectedRole(),
    rolesWithSubModels: [],
    roles: [],
  }),

  mutations: {
    setSelectedRole(state, role) {
      Vue.set(state, "selectedRole", role);
    },
    setRoles(state, roles) {
      Vue.set(state, "roles", roles);
    },
    setRolesWithSubModels(state, rolesWithSubModels) {
      Vue.set(state, "rolesWithSubModels", rolesWithSubModels);
    },
    setDefaultSelectedRole(state) {
      Vue.set(state, "selectedRole", getDefaultSelectedRole());
    },
    setDefaultRoleModule(state) {
      Vue.set(state, "selectedRole", getDefaultSelectedRole());
      Vue.set(state, "rolesWithSubModels", []);
      Vue.set(state, "roles", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createRole: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/roles/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadRoles: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/entity").then((response) => {
        context.commit("setRoles", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadRole: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/entity/" + request.id).then((response) => {
        context.commit("setSelectedRole", response.data);
        return response.data;
      });
    },

    loadDraftRole: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/entity/draft/" + intentId).then((response) => {
        context.commit("setSelectedRole", response.data);
        return response.data;
      });
    },

    loadPublishedRoles: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedRoleHistory: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/history/" + role.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteRole: (context, role) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/roles/entity/" + role.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          role.intents = intents;
          role.intentId = response.data.id;
          return role;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftRole: (context, role) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/roles/draft/" + role.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishRole: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/publish/" + role.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (role.intents[0].type === "DELETE_ROLE") {
          let roles = context.getters.getSegments;
          roles.splice(roles.indexOf(role), 1);
          context.commit("setRoles", roles);
        }
        return response.data;
      });
    },

    rejectRole: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/reject/" + role.intentId).then((response) => {
        helper.recallOrRejectEntity(role, "role");
        return response.data;
      });
    },

    sendToApprovalRoles: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/sendToApproval/" + role.intentId).then((response) => {
        if (role.intents[0].type === "CREATE_ROLE") {
          role.intents[0].status = "WAITING_APPROVAL";
        } else if (role.intents[0].type === "UPDATE_ROLE") {
          role.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallRole: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/recall/" + role.intentId).then((response) => {
        helper.recallOrRejectEntity(role, "role");
        return response.data;
      });
    },

    cancelRole: (context, role) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/cancel/" + role.intentId).then((response) => {
        return response.data;
      });
    },

    loadRolesWithSubModels: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/roles/entity/with-sub-models").then((response) => {
        context.commit("setRolesWithSubModels", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },
  },

  getters: {
    getSelectedRole: (state) => {
      return state.selectedRole;
    },
    getRoles: (state) => {
      return state.roles;
    },
    getRolesWithSubModels: (state) => {
      return state.rolesWithSubModels;
    },
  },
};
